module.exports = __webpack_public_path__ + "69d42a5b0924623ce2beea5a8ca1e9d6.png";